import React from 'react';
function Renew({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      strokeLinecap="round"
      strokeLinejoin="round"
      {...otherProps}
    >
      <path d="M20.1 3v5.4h-5.4" />
      <path d="M3.9 12a8.1 8.1 0 0 1 13.5-6.03l2.7 2.43M3.9 21v-5.4h5.4" />
      <path d="M20.1 12a8.1 8.1 0 0 1-13.5 6.03L3.9 15.6" />
    </svg>
  );
}

export default Renew;
